<template>
  <div>
    <div class="hero">
      <div class="img-bg">
        <img :src="require('@/assets/svg/hero-img-blog.svg')" alt="" />
      </div>
      <div class="overlay-text">
        <b-img
            :src="providerImgURL"
            v-bind="mainProps"
            fluid
            alt="Fluid image"
        />
        <h1>{{providerName}} Management</h1>
        <p>
          Take control of how you would like to be presented to the world.
        </p>
        <b-link
            @click="handleEditOrganizationClick"
        >
          Edit Organization
        </b-link>
        <div class="d-flex">
          <button
            class="btn-round-outline tourblog-3"
            @click="$bvModal.show(heroBannerVideo)"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9Z"
                fill="var(--theme-color)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.14611 5.33875C7.38997 5.20823 7.68588 5.22254 7.91603 5.37596L12.416 8.37596C12.6247 8.51506 12.75 8.74924 12.75 9C12.75 9.25077 12.6247 9.48494 12.416 9.62404L7.91603 12.624C7.68588 12.7775 7.38997 12.7918 7.14611 12.6613C6.90224 12.5307 6.75 12.2766 6.75 12V6C6.75 5.7234 6.90224 5.46926 7.14611 5.33875ZM8.25 7.40139V10.5986L10.6479 9L8.25 7.40139Z"
                fill="var(--theme-color)"
              />
            </svg>
            See Video Tutorials
          </button>
        </div>
      </div>
    </div>

    <TutorialModal
      :id="heroBannerVideo"
      :img="video.thumbnail"
      :moreVideos="moreVideos"
      :video="video"
    />
    <!-- <link-bank></link-bank> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
import VideoModal from "@/components/common/videoModal";

export default {
  name: "guide-hero-banner",
  components: {},
  mounted() {
    // this.getAccount();
  },
  props: {
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile",
      user: "user/user"
    }),
    providerName(){
      return this.provider && this.provider.info && this.provider.info.name ?
          this.provider.info.name : "Provider";
    },
    providerImgURL(){
      return this.provider && this.provider.info && this.provider.info.imgURL ?
          this.provider.info.imgURL : "https://picsum.photos/300/150/?image=41";
    },
  },
  methods: {
    handleEditOrganizationClick() {
      this.$emit("edit-org-click");
    }
  },
  data() {
    return {
      mainProps: { blank: false, blankColor: '#777', width: 200, height: 200, class: 'm1' },
      heroBannerVideo: "blog-hero-banner-tutorial",
      connectedAccount: {},
      incompeleteBoarding: false,
      playing: false,
      video: {
        videoId: "530298833",
        thumbnail: require("@/assets/svg/video.svg"),
        text: "Title Video",
        id: "232"
      },
      moreVideos: [
        {
          id: "1334",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        },
        {
          id: "133234",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        },
        {
          id: "1332344",
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        },
        {
          thumbnail: require("@/assets/svg/video.svg"),
          text: "Title Video",
          videoId: "529254176"
        }
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.link-to-bank {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;

  /* Primary */

  color: var(--theme-color);
  background: none;
  border: none;
  margin-left: 15px;
}
.hero {
  position: relative;
  margin-bottom: 24px;
  .overlay-text {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left: 50px;
    h1 {
      font-size: 24px;
      line-height: 33px;
      color: #474d52;
      font-weight: bold;
    }
    p {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
    }
    .btn-round-outline {
      svg {
        margin-right: 6px;
      }
    }
  }
  .img-bg {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: auto;
      min-height: 170px;
      object-fit: cover;
    }
  }
}
.video-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .play-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
  .close-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
@media (min-width: 991px) {
  .guide-management .hero .overlay-text p {
    max-width: 40%;
  }
}
.guide-modal___BV_modal_content_ {
  border-radius: 16px;
}
.incomplete-process {
  margin-top: 10px;
  width: 100%;
  display: block;
  p {
    min-width: 700px;
  }
}
.connected-account {
  margin-left: 5px;
  margin-top: 6px;
}
</style>
